/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import IconButton from "@mui/material/IconButton";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Popover from "@mui/material/Popover";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import parseHtml from "html-react-parser";
import MenuList from "@mui/material/MenuList";
import { styled } from "@mui/material/styles";
// import MessageIcon from "@mui/icons-material/Message";
import { INotification } from "../../../types/notification";
import Button from "@mui/material/Button";
import Badge from "@mui/material/Badge";
import notificationsService from "../../../service/notifications.service";
import { useAppContext } from "../../../contexts/useStorageContext";

const MarkReadButton = styled(Button)(({ theme }) => ({
  height: "20px",
  fontSize: "13px",
  borderRadius: "100px",
  color: theme.palette.warning.main,
  border: "solid 1px",
  background: "#0000",
  transform: "scale(1)",
  transition: "0.2s",
  "&:hover": {
    transform: "scale(1.1)",
    color: "white",
    background: theme.palette.warning.main,
    border: "none",
  },
  "&:active": {
    transform: "scale(0.9)",
    color: "white",
    background: theme.palette.warning.main,
    border: "none",
  },
}));

export function NotificationIconButton() {
  const { state } = useAppContext();
  const { loggedInUserInfo } = state;
  const [anchorElNoti, setAnchorElNoti] = React.useState<null | HTMLElement>(
    null
  );
  const [notifications, setNotifications] = React.useState<INotification[]>([]);

  const fetchUnreadNotifications = async () => {
    const result = await notificationsService.get({});
    setNotifications(result?.data || []);
  };

  const handleOpenNotifications = React.useCallback(
    async (event: React.MouseEvent<HTMLElement>) => {
      setAnchorElNoti(event.currentTarget);
      if (notifications?.length) {
        await notificationsService.read(notifications.map((n) => n._id));
      }
    },
    [notifications]
  );
  const handleCloseNotiMenu = () => {
    setAnchorElNoti(null);
  };

  React.useEffect(() => {
    fetchUnreadNotifications();
  }, []);

  return (
    <>
      <IconButton onClick={handleOpenNotifications}>
        <Badge
          badgeContent={
            notifications?.filter(
              (n) => !n.seenUserIds?.includes(loggedInUserInfo?._id || "")
            ).length || 0
          }
          color={
            notifications?.filter(
              (n) => !n.seenUserIds?.includes(loggedInUserInfo?._id || "")
            ).length
              ? "error"
              : "default"
          }
        >
          <NotificationsNoneIcon
            sx={{
              color: "button.black",
              fontSize: { xs: "30px", lg: "35px" },
            }}
          />
        </Badge>
      </IconButton>

      <Popover
        sx={{ mt: "45px" }}
        id="menu-appbar-noti-btn"
        anchorEl={anchorElNoti}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElNoti)}
        onClose={handleCloseNotiMenu}
      >
        <Box sx={{ width: 400 }}>
          <Box px={2} pt={1} pb={0}>
            <Typography fontSize={17}>{`Notifications`}</Typography>
          </Box>
          {notifications?.length ? (
            <Box>
              <MenuList sx={{ maxHeight: "400px", overflow: "auto" }}>
                {notifications.map((notification) => (
                  <Box
                    key={notification._id}
                    sx={{
                      borderTop: "solid 1px #ddd",
                      padding: "6px 14px",
                    }}
                  >
                    <Box
                      color={`${notification.type}.main`}
                      sx={{ fontSize: "15px", fontWeight: "500", mb: "4px" }}
                    >
                      {notification.title}
                    </Box>
                    <Box
                      sx={{
                        fontSize: "14px",
                        opacity: 0.8,
                        "& a": {
                          color: "#0288d1",
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {parseHtml(notification.description)}
                    </Box>
                  </Box>
                ))}
              </MenuList>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "200px",
                opacity: 0.5,
              }}
            >
              No notifications
            </Box>
          )}
        </Box>
      </Popover>
    </>
  );
}
